import { render, staticRenderFns } from "./Medcert.vue?vue&type=template&id=368f853a&scoped=true&"
import script from "./Medcert.vue?vue&type=script&lang=js&"
export * from "./Medcert.vue?vue&type=script&lang=js&"
import style0 from "./Medcert.vue?vue&type=style&index=0&id=368f853a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f853a",
  null
  
)

export default component.exports